/**
        Cut a description and add ellipsis
     */
angular.module('filters').filter('cut', () => (value, wordwise, max, tail) => {

    let lastspace;

    if (!value) {

        return '';

    }

    max = parseInt(max, 10);

    if (!max) {

        return value;

    }

    if (value.length <= max) {

        return value;

    }

    value = value.substr(0, max);

    if (wordwise) {

        lastspace = value.lastIndexOf(' ');
        if (lastspace !== -1) {

            value = value.substr(0, lastspace);

        }

    }
    if (value.slice(-1) === '.') {

        return `${value}..`;

    }
    return value + (tail || '...');

});



// WEBPACK FOOTER //
// ./scripts/filters/limitDescription.js